import BoxEditor from "@components/BoxEditor";
import BoxImage from "@components/BoxImage";
import ButtonContainer from "@components/ButtonContainer";
import { timestampToString } from "@helpers/dates.format";
import { INews } from "@interfaces/news";
import { ReactElement } from "react";
import { Col } from "reactstrap";

interface IDetailForm {
  data: INews;
}

const DetailForm = ({ data }: IDetailForm): ReactElement => (
  <form className="form">
    <Col md={data?.imageUrl ? 7 : 12}>
      <div className="form__form-group">
        <span className="form__form-group-label">Title</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.title} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Date</span>
        <div className="form__form-group-field">
          <input type="text" value={timestampToString(data?.date)} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Summary</span>
        <div className="form__form-group-field">
          <textarea value={data?.summary} disabled />
        </div>
      </div>
    </Col>
    {data?.imageUrl && (
      <Col md={5}>
        <div className="form__form-group">
          <BoxImage urlImage={data?.imageUrl} title="Image" />
        </div>
      </Col>
    )}

    <Col md={12}>
      <div className="form__form-group">
        <span className="form__form-group-label">Body</span>
        <div className="form__form-group-field">
          <BoxEditor body={data?.body} />
        </div>
      </div>
    </Col>

    <ButtonContainer />
  </form>
);

export default DetailForm;
